/** 클라이언트·서버가 같은 모양의 JSON 을 주고받는다. */

export type AuthMode = 'login' | 'register';

export interface AuthCreds {
  mode: AuthMode;
  account: string;
  password: string;
  nick: string;
  serverUrl?: string;
}

export type NetMsg =
  | {
      t: 'hello';
      mode: AuthMode;
      account: string;
      password: string;
      nick?: string;
      jobId: string;
      save: unknown;
    }
  | { t: 'welcome'; id: string; name: string; account: string; save: unknown | null }
  | { t: 'nickOk'; name: string }
  | { t: 'reject'; reason: string }
  | { t: 'pose'; mapId: string; x: number; y: number; vx: number; vy: number; facing: 1 | -1; mode: string }
  | { t: 'snapshot'; tick: number; you: { x: number; y: number }; others: RemotePose[] }
  | { t: 'chat'; text: string }
  | { t: 'chatLine'; from: string; text: string; whisper?: boolean }
  | { t: 'partyInvite'; name: string }
  | { t: 'party'; leader: string; members: { id: string; name: string }[] }
  | { t: 'claim'; key: string }
  | { t: 'claimOk'; key: string; ownerId: string; ownerName: string }
  | { t: 'claimDeny'; key: string; ownerName: string }
  | { t: 'kill'; key: string; exp: number; mapId: string; x: number; y: number }
  | { t: 'shareExp'; amount: number; from: string }
  | { t: 'save'; save: unknown }
  | { t: 'setNick'; nick: string }
  | { t: 'friendAdd'; nick: string }
  | { t: 'friendAccept'; nick: string }
  | { t: 'friendRemove'; nick: string }
  | { t: 'whisper'; to: string; text: string }
  | { t: 'friendList'; friends: FriendView[]; incoming: string[] }
  | { t: 'ping' }
  | { t: 'pong' };

export interface FriendView {
  nick: string;
  online: boolean;
  mapId: string | null;
}

export interface RemotePose {
  id: string;
  name: string;
  mapId: string;
  x: number;
  y: number;
  vx: number;
  vy: number;
  facing: 1 | -1;
  mode: string;
}

export function parseNetMsg(raw: string): NetMsg | null {
  try {
    const v = JSON.parse(raw) as NetMsg;
    if (!v || typeof v !== 'object' || typeof v.t !== 'string') return null;
    return v;
  } catch {
    return null;
  }
}
